import React from 'react';

const FoodIntakeFooter = (props) => {
  const {total, columns} = props;

  return (
    <tr>
      <td>{total}</td>
      {columns.map((value, index)  => (
        <td key={index}></td>
      ))}
    </tr>
  );
}

export default FoodIntakeFooter;
